import { tokens } from '../theme/tokens';

// The named colours below are views of the brand tokens (src/theme/tokens.ts); change them there. The
// chart slots and the JSON viewer scheme are data palettes, not brand, and stay here.
export const colors = {
  defaultGrey: tokens.sidebar,
  red: tokens.status.error,
  green: tokens.status.success,
  blue: tokens.primary.main,
  orange: tokens.status.warning,
  // The three dashboard vaccine slots, in fixed order. Same three hues as before, stepped darker so each
  // one clears 3:1 against a white card and the pairs stay apart under deuteranopia and tritanopia.
  // DashboardSettings paints its supply swatches from these, so the settings screen follows automatically.
  barChartA: '#9333ea',
  barChartB: '#0891b2',
  barChartC: '#4f46e5',
  barChartLine: '#ff7300',
  jsonViewTheme: {
    scheme: 'google',
    author: 'seth wright',
    base00: '#1d1f21',
    base01: '#282a2e',
    base02: '#373b41',
    base03: '#969896',
    base04: '#b4b7b4',
    base05: '#c5c8c6',
    base06: '#e0e0e0',
    base07: '#ffffff',
    base08: '#CC342B',
    base09: '#F96A38',
    base0A: '#FBA922',
    base0B: '#198844',
    base0C: '#3971ED',
    base0D: '#3971ED',
    base0E: '#A36AC7',
    base0F: '#3971ED'
  }
};

export const lineColors = [
  colors.blue,
  colors.green,
  colors.orange,
  colors.barChartA,
  colors.barChartB,
  colors.barChartC,
  colors.barChartLine
];
